import { render } from "./DatePickerEditorCmp.vue?vue&type=template&id=56efac43"
import script from "./DatePickerEditorCmp.vue?vue&type=script&lang=js"
export * from "./DatePickerEditorCmp.vue?vue&type=script&lang=js"

import "./DatePickerEditorCmp.vue?vue&type=style&index=0&id=56efac43&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__